import { ChangeAction } from '../../apis/graphql';
import type { DateRange as Range } from '../../models';

export enum ChangesPrefixes {
  AdRotation = 'ad-rotation',
}

export enum NestedArrayChangesProperties {
  AdList = 'ad-list',
}

export const ROWS_TO_IGNORE = [
  'updated-at',
  'created-at',
  'permitted-creative-type-list',
  'ad-rotation.ad-id',
  'ad-rotation.order',
];

export const ROWS_TO_IGNORE_DUPLICATE = ['id'];

export const UNIT_COST_FIELD_NAME = 'unit-cost';
export const UNIT_COST_DTO_FIELD_NAME = 'unit-cost-dto';
export const LEGACY_UNIT_COST_CURRENCY = 'USD';

export const changeActionToTitleActionMap: Record<ChangeAction, string> = {
  [ChangeAction.Addition]: 'created',
  [ChangeAction.Removal]: 'removed',
  [ChangeAction.Update]: 'data changed',
};

export const arrayChangesTitles: Record<string, string> = {
  adList: 'Ad',
};

export const NOTIFY_ON_NETWORK_STATUS_CHANGE = true;
export const LIMIT_AUDITS = 25;
export const DEFAULT_AMOUNT_OF_LOGS_TO_SHOW = 12;
export const DEFAULT_AMOUNT_OF_NOTIFICATIONS_LOGS_TO_SHOW = 25;

export const INITIAL_DATE_RANGE: Range = {
  startDate: '',
  endDate: null,
  pacingShare: null,
};

export const INITIAL_PAGINATION_OPTIONS = {
  offset: 0,
  limit: LIMIT_AUDITS,
};
